import { VtSettingsListGroupLink } from '@shared/interfaces/settings-list-group-link';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { AlertSettingsRouteName } from '@pages/settings-page/settings-route-names';

export const alertsMenuItemTitle = 'Settings.Alerts';

export const alertsMenuItemLinks: VtSettingsListGroupLink[] = [
  {
    label: 'Settings.Alerts.AlertsSetupLink',
    routerLink: AlertSettingsRouteName.AlertSetup,
    permissions: [RolesAndPermissions.AlertSettingsRead],
  },
  {
    label: 'Settings.Alerts.AlertLog',
    routerLink: AlertSettingsRouteName.AlertLog,
    permissions: [RolesAndPermissions.AlertSettingsRead],
  },
];
